import { createPortfolioApi, ProviderErrorResponse } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

export { ProviderErrorResponse };
export type { IPortfolioActiveSchedule } from '@d-orca/shared/client/apis';

// The shared portfolio API bound to the web transport (cookie `authedFetch`).
// Mobile binds the same factory to its Bearer-sid transport.
export const { fetchPortfolio } = createPortfolioApi(authedFetch);
